import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const NutritionIodineDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const slc26a4 = getGenePalette(geneColors.SLC26A4);
  const tpo = getGenePalette(geneColors.TPO);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18284_196592)">
        <rect width={1024} height={1344} transform="translate(0 176)" fill="white" />
        <g id="iodine-diagram">
          <rect width={1024} height={1344} transform="translate(0 176)" fill="white" />
          <g id="lines">
            <path
              id="Vector_2"
              d="M41.5 497.5L985.5 497.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
            <g id="Frame 469">
              <text
                id="Section Divider Label"
                transform="translate(41 498)"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={0} y={26.196}>
                  Thyroid
                </tspan>
              </text>
              <text
                id="Section Divider SubLabel"
                transform="translate(41 530)"
                fill="#818181"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={0} y={16.76}>
                  (Thyroid follicular cell)
                </tspan>
              </text>
            </g>
          </g>
          <g id="lines_2">
            <path
              id="Vector_3"
              d="M412.741 356.7L412.741 356L411.341 356L411.341 356.7L412.041 356.7L412.741 356.7ZM412.041 549L416.083 542L408 542L412.041 549ZM412.041 356.7L411.341 356.7L411.341 542.7L412.041 542.7L412.741 542.7L412.741 356.7L412.041 356.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_3">
            <path
              id="Vector_4"
              d="M412.741 641.7L412.741 641L411.341 641L411.341 641.7L412.041 641.7L412.741 641.7ZM412.041 836L416.083 829L408 829L412.041 836ZM412.041 641.7L411.341 641.7L411.341 829.7L412.041 829.7L412.741 829.7L412.741 641.7L412.041 641.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_4">
            <text
              id="Line Label"
              transform="translate(459 852)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={48.1328} y={16.086}>
                OXIDATION
              </tspan>
            </text>
            <path
              id="Vector_5"
              d="M459.7 882.342H459V883.742H459.7V883.042V882.342ZM617 883.042L610 879V887.083L617 883.042ZM459.7 883.042V883.742L610.7 883.742V883.042V882.342L459.7 882.342V883.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_5">
            <path
              id="Vector_6"
              d="M708.7 1136.34H708V1137.74H708.7V1137.04V1136.34ZM829 1137.04L822 1133V1141.08L829 1137.04ZM708.7 1137.04V1137.74H822.7V1137.04V1136.34H708.7V1137.04Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_6">
            <path
              id="Vector_7"
              d="M768.508 985.848L769.003 985.353L768.013 984.363L767.518 984.858L768.013 985.353L768.508 985.848ZM662.858 1090.51L670.666 1088.42L664.95 1082.7L662.858 1090.51ZM768.013 985.353L767.518 984.858L666.818 1085.56L667.313 1086.05L667.808 1086.55L768.508 985.848L768.013 985.353Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_7">
            <path
              id="Vector_8"
              d="M859.508 1182.85L860.003 1182.35L859.013 1181.36L858.518 1181.86L859.013 1182.35L859.508 1182.85ZM702.683 1338.68L710.49 1336.59L704.775 1330.88L702.683 1338.68ZM859.013 1182.35L858.518 1181.86L706.643 1333.73L707.137 1334.23L707.632 1334.72L859.508 1182.85L859.013 1182.35Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_8">
            <path
              id="Vector_9"
              d="M663.742 1184.7C663.742 1184.31 663.428 1184 663.042 1184C662.655 1184 662.342 1184.31 662.342 1184.7L663.042 1184.7L663.742 1184.7ZM663.041 1296L667.083 1289L659 1289L663.041 1296ZM662.342 1186.69C662.342 1187.07 662.655 1187.39 663.042 1187.39C663.428 1187.39 663.742 1187.07 663.742 1186.69L663.042 1186.69L662.342 1186.69ZM663.742 1190.66C663.742 1190.28 663.428 1189.96 663.042 1189.96C662.655 1189.96 662.342 1190.28 662.342 1190.66L663.042 1190.66L663.742 1190.66ZM662.342 1194.64C662.342 1195.02 662.655 1195.34 663.042 1195.34C663.428 1195.34 663.742 1195.02 663.742 1194.64L663.042 1194.64L662.342 1194.64ZM663.742 1198.61C663.742 1198.23 663.428 1197.91 663.042 1197.91C662.655 1197.91 662.342 1198.23 662.342 1198.61L663.042 1198.61L663.742 1198.61ZM662.342 1202.59C662.342 1202.97 662.655 1203.29 663.042 1203.29C663.428 1203.29 663.742 1202.97 663.742 1202.59L663.042 1202.59L662.342 1202.59ZM663.742 1206.56C663.742 1206.18 663.428 1205.86 663.042 1205.86C662.655 1205.86 662.342 1206.18 662.342 1206.56L663.042 1206.56L663.742 1206.56ZM662.342 1210.54C662.342 1210.92 662.655 1211.24 663.042 1211.24C663.428 1211.24 663.742 1210.92 663.742 1210.54L663.042 1210.54L662.342 1210.54ZM663.742 1214.51C663.742 1214.13 663.428 1213.81 663.042 1213.81C662.655 1213.81 662.342 1214.13 662.342 1214.51L663.042 1214.51L663.742 1214.51ZM662.342 1218.49C662.342 1218.87 662.655 1219.19 663.042 1219.19C663.428 1219.19 663.742 1218.87 663.742 1218.49L663.042 1218.49L662.342 1218.49ZM663.742 1222.46C663.742 1222.08 663.428 1221.76 663.042 1221.76C662.655 1221.76 662.342 1222.08 662.342 1222.46L663.042 1222.46L663.742 1222.46ZM662.342 1226.44C662.342 1226.82 662.655 1227.14 663.042 1227.14C663.428 1227.14 663.742 1226.82 663.742 1226.44L663.042 1226.44L662.342 1226.44ZM663.742 1230.41C663.742 1230.03 663.428 1229.71 663.042 1229.71C662.655 1229.71 662.342 1230.03 662.342 1230.41L663.042 1230.41L663.742 1230.41ZM662.342 1234.39C662.342 1234.77 662.655 1235.09 663.042 1235.09C663.428 1235.09 663.742 1234.77 663.742 1234.39L663.042 1234.39L662.342 1234.39ZM663.742 1238.36C663.742 1237.98 663.428 1237.66 663.042 1237.66C662.655 1237.66 662.342 1237.98 662.342 1238.36L663.042 1238.36L663.742 1238.36ZM662.342 1242.34C662.342 1242.72 662.655 1243.04 663.042 1243.04C663.428 1243.04 663.742 1242.72 663.742 1242.34L663.042 1242.34L662.342 1242.34ZM663.742 1246.31C663.742 1245.93 663.428 1245.61 663.042 1245.61C662.655 1245.61 662.342 1245.93 662.342 1246.31L663.042 1246.31L663.742 1246.31ZM662.342 1250.29C662.342 1250.67 662.655 1250.99 663.042 1250.99C663.428 1250.99 663.742 1250.67 663.742 1250.29L663.042 1250.29L662.342 1250.29ZM663.742 1254.26C663.742 1253.88 663.428 1253.56 663.042 1253.56C662.655 1253.56 662.342 1253.88 662.342 1254.26L663.042 1254.26L663.742 1254.26ZM662.342 1258.24C662.342 1258.62 662.655 1258.94 663.042 1258.94C663.428 1258.94 663.742 1258.62 663.742 1258.24L663.042 1258.24L662.342 1258.24ZM663.742 1262.21C663.742 1261.83 663.428 1261.51 663.042 1261.51C662.655 1261.51 662.342 1261.83 662.342 1262.21L663.042 1262.21L663.742 1262.21ZM662.342 1266.19C662.342 1266.57 662.655 1266.89 663.042 1266.89C663.428 1266.89 663.742 1266.57 663.742 1266.19L663.042 1266.19L662.342 1266.19ZM663.742 1270.16C663.742 1269.78 663.428 1269.46 663.042 1269.46C662.655 1269.46 662.342 1269.78 662.342 1270.16L663.042 1270.16L663.742 1270.16ZM662.342 1274.14C662.341 1274.52 662.655 1274.84 663.041 1274.84C663.428 1274.84 663.741 1274.52 663.741 1274.14L663.041 1274.14L662.342 1274.14ZM663.741 1278.11C663.741 1277.73 663.428 1277.41 663.041 1277.41C662.655 1277.41 662.341 1277.73 662.341 1278.11L663.041 1278.11L663.741 1278.11ZM662.341 1282.09C662.341 1282.47 662.655 1282.79 663.041 1282.79C663.428 1282.79 663.741 1282.47 663.741 1282.09L663.041 1282.09L662.341 1282.09ZM663.741 1286.06C663.741 1285.68 663.428 1285.36 663.041 1285.36C662.655 1285.36 662.341 1285.68 662.341 1286.06L663.041 1286.06L663.741 1286.06ZM662.341 1290.04C662.341 1290.42 662.655 1290.74 663.041 1290.74C663.428 1290.74 663.741 1290.42 663.741 1290.04L663.041 1290.04L662.341 1290.04ZM663.741 1294.01C663.741 1293.63 663.428 1293.31 663.041 1293.31C662.655 1293.31 662.341 1293.63 662.341 1294.01L663.041 1294.01L663.741 1294.01ZM663.042 1184.7L662.342 1184.7L662.342 1186.69L663.042 1186.69L663.742 1186.69L663.742 1184.7L663.042 1184.7ZM663.042 1190.66L662.342 1190.66L662.342 1194.64L663.042 1194.64L663.742 1194.64L663.742 1190.66L663.042 1190.66ZM663.042 1198.61L662.342 1198.61L662.342 1202.59L663.042 1202.59L663.742 1202.59L663.742 1198.61L663.042 1198.61ZM663.042 1206.56L662.342 1206.56L662.342 1210.54L663.042 1210.54L663.742 1210.54L663.742 1206.56L663.042 1206.56ZM663.042 1214.51L662.342 1214.51L662.342 1218.49L663.042 1218.49L663.742 1218.49L663.742 1214.51L663.042 1214.51ZM663.042 1222.46L662.342 1222.46L662.342 1226.44L663.042 1226.44L663.742 1226.44L663.742 1222.46L663.042 1222.46ZM663.042 1230.41L662.342 1230.41L662.342 1234.39L663.042 1234.39L663.742 1234.39L663.742 1230.41L663.042 1230.41ZM663.042 1238.36L662.342 1238.36L662.342 1242.34L663.042 1242.34L663.742 1242.34L663.742 1238.36L663.042 1238.36ZM663.042 1246.31L662.342 1246.31L662.342 1250.29L663.042 1250.29L663.742 1250.29L663.742 1246.31L663.042 1246.31ZM663.042 1254.26L662.342 1254.26L662.342 1258.24L663.042 1258.24L663.742 1258.24L663.742 1254.26L663.042 1254.26ZM663.042 1262.21L662.342 1262.21L662.342 1266.19L663.042 1266.19L663.742 1266.19L663.742 1262.21L663.042 1262.21ZM663.042 1270.16L662.342 1270.16L662.342 1274.14L663.041 1274.14L663.741 1274.14L663.742 1270.16L663.042 1270.16ZM663.041 1278.11L662.341 1278.11L662.341 1282.09L663.041 1282.09L663.741 1282.09L663.741 1278.11L663.041 1278.11ZM663.041 1286.06L662.341 1286.06L662.341 1290.04L663.041 1290.04L663.741 1290.04L663.741 1286.06L663.041 1286.06Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_9">
            <path
              id="Vector_10"
              d="M769.198 984.858L768.703 984.363L767.713 985.353L768.208 985.848L768.703 985.353L769.198 984.858ZM873.858 1090.51L871.766 1082.7L866.05 1088.42L873.858 1090.51ZM768.703 985.353L768.208 985.848L868.908 1086.55L869.403 1086.05L869.898 1085.56L769.198 984.858L768.703 985.353Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_10">
            <path
              id="Vector_11"
              d="M42.5 677.5L985.5 677.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
            <g id="Frame 469_2">
              <text
                id="Section Divider Label_2"
                transform="translate(42 678)"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={0} y={26.196}>
                  Thyroid
                </tspan>
              </text>
              <text
                id="Section Divider SubLabel_2"
                transform="translate(42 710)"
                fill="#818181"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={0} y={16.76}>
                  (Thyroid follicular lumen) or (Internal space of{" "}
                </tspan>
                <tspan x={0} y={40.76}>
                  thyroid follicule)
                </tspan>
              </text>
            </g>
          </g>
          <g id="lines_11">
            <g id="Frame 469_3">
              <text
                id="Section Divider Label_3"
                transform="translate(43 231)"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={0} y={26.196}>
                  Bloodstream
                </tspan>
              </text>
            </g>
          </g>
          <g id="Vitamin-Mineral_2">
            <g id="Frame 470">
              <g id="diamond_2">
                <path
                  id="Vector_12"
                  d="M412.709 268.151L452.709 308.151L412.709 348.151L372.709 308.151L412.709 268.151Z"
                  stroke="#1A1A1A"
                  strokeWidth={1.4}
                />
                <g id="label">
                  <text
                    fill="#1A1A1A"
                    style={{ whiteSpace: "pre" }}
                    xmlSpace="preserve"
                    fontFamily="Gilroy W05 Medium"
                    fontSize={18}
                    letterSpacing="0em"
                  >
                    <tspan x={408.057} y={314.129}>
                      I
                    </tspan>
                  </text>
                  <text
                    fill="#1A1A1A"
                    style={{ whiteSpace: "pre" }}
                    xmlSpace="preserve"
                    fontFamily="Gilroy W05 Medium"
                    fontSize={18}
                    letterSpacing="0em"
                  >
                    <tspan x={412.434} y={314.129}>
                      &#x207b;
                    </tspan>
                  </text>
                </g>
              </g>
            </g>
          </g>
          <g id="Vitamin-Mineral_3">
            <g id="Frame 470_2">
              <g id="diamond_3">
                <path
                  id="Vector_13"
                  d="M412.709 555.151L452.709 595.151L412.709 635.151L372.709 595.151L412.709 555.151Z"
                  stroke="#1A1A1A"
                  strokeWidth={1.4}
                />
                <g id="label_2">
                  <text
                    fill="#1A1A1A"
                    style={{ whiteSpace: "pre" }}
                    xmlSpace="preserve"
                    fontFamily="Gilroy W05 Medium"
                    fontSize={18}
                    letterSpacing="0em"
                  >
                    <tspan x={408.057} y={601.129}>
                      I
                    </tspan>
                  </text>
                  <text
                    fill="#1A1A1A"
                    style={{ whiteSpace: "pre" }}
                    xmlSpace="preserve"
                    fontFamily="Gilroy W05 Medium"
                    fontSize={18}
                    letterSpacing="0em"
                  >
                    <tspan x={412.434} y={601.129}>
                      &#x207b;
                    </tspan>
                  </text>
                </g>
              </g>
            </g>
          </g>
          <g id="Vitamin-Mineral_4">
            <g id="Frame 470_3">
              <g id="diamond_4">
                <path
                  id="Vector_14"
                  d="M412.709 842.151L452.709 882.151L412.709 922.151L372.709 882.151L412.709 842.151Z"
                  stroke="#1A1A1A"
                  strokeWidth={1.4}
                />
                <g id="label_3">
                  <text
                    fill="#1A1A1A"
                    style={{ whiteSpace: "pre" }}
                    xmlSpace="preserve"
                    fontFamily="Gilroy W05 Medium"
                    fontSize={18}
                    letterSpacing="0em"
                  >
                    <tspan x={408.057} y={888.129}>
                      I
                    </tspan>
                  </text>
                  <text
                    fill="#1A1A1A"
                    style={{ whiteSpace: "pre" }}
                    xmlSpace="preserve"
                    fontFamily="Gilroy W05 Medium"
                    fontSize={18}
                    letterSpacing="0em"
                  >
                    <tspan x={412.434} y={888.129}>
                      &#x207b;
                    </tspan>
                  </text>
                </g>
              </g>
            </g>
          </g>
          <g id="Vitamin-Mineral_5">
            <g id="Frame 470_4">
              <g id="diamond_5">
                <path
                  id="Vector_15"
                  d="M662.709 1097.15L702.709 1137.15L662.709 1177.15L622.709 1137.15L662.709 1097.15Z"
                  stroke="#1A1A1A"
                  strokeWidth={1.4}
                />
                <text
                  id="label_4"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={18}
                  letterSpacing="0em"
                >
                  <tspan x={653.392} y={1143.13}>
                    T4
                  </tspan>
                </text>
              </g>
            </g>
          </g>
          <g id="Vitamin-Mineral_6">
            <g id="Frame 470_5">
              <g id="diamond_6">
                <path
                  id="Vector_16"
                  d="M873.709 1097.15L913.709 1137.15L873.709 1177.15L833.709 1137.15L873.709 1097.15Z"
                  stroke="#1A1A1A"
                  strokeWidth={1.4}
                />
                <text
                  id="label_5"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={18}
                  letterSpacing="0em"
                >
                  <tspan x={864.436} y={1143.13}>
                    T3
                  </tspan>
                </text>
              </g>
            </g>
          </g>
          <g id="Vitamin-Mineral_7">
            <g id="Frame 470_6">
              <g id="diamond_7">
                <path
                  id="Vector_17"
                  d="M662.709 1308.15L702.709 1348.15L662.709 1388.15L622.709 1348.15L662.709 1308.15Z"
                  stroke="#1A1A1A"
                  strokeWidth={1.4}
                />
                <text
                  id="label_6"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={18}
                  letterSpacing="0em"
                >
                  <tspan x={650.483} y={1354.13}>
                    rT3
                  </tspan>
                </text>
              </g>
            </g>
          </g>
          <g id="Frame 427">
            <g id="Vitamin-Mineral_8">
              <g id="Frame 470_7">
                <g id="diamond_8">
                  <path
                    id="Vector_18"
                    d="M678.709 842.151L718.709 882.151L678.709 922.151L638.709 882.151L678.709 842.151Z"
                    stroke="#1A1A1A"
                    strokeWidth={1.4}
                  />
                  <g id="label_7">
                    <text
                      fill="#1A1A1A"
                      style={{ whiteSpace: "pre" }}
                      xmlSpace="preserve"
                      fontFamily="Gilroy W05 Medium"
                      fontSize={18}
                      letterSpacing="0em"
                    >
                      <tspan x={673.989} y={888.129}>
                        I
                      </tspan>
                    </text>
                    <text
                      fill="#1A1A1A"
                      style={{ whiteSpace: "pre" }}
                      xmlSpace="preserve"
                      fontFamily="Gilroy W05 Medium"
                      fontSize={18}
                      letterSpacing="0em"
                    >
                      <tspan x={678.366} y={888.129}>
                        &#x2082;
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <text
                id="Title"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={655.742} y={942.448}>
                  Iodine
                </tspan>
              </text>
            </g>
            <text
              id="+"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={32}
              letterSpacing="0em"
            >
              <tspan x={756.859} y={887.88}>
                +
              </tspan>
            </text>
            <g id="Vitamin-Mineral_9">
              <g id="Frame 470_8">
                <g id="diamond_9">
                  <path
                    id="Vector_19"
                    d="M860.709 842.151L900.709 882.151L860.709 922.151L820.709 882.151L860.709 842.151Z"
                    stroke="#1A1A1A"
                    strokeWidth={1.4}
                  />
                  <text
                    id="label_8"
                    fill="#1A1A1A"
                    style={{ whiteSpace: "pre" }}
                    xmlSpace="preserve"
                    fontFamily="Gilroy W05 Medium"
                    fontSize={18}
                    letterSpacing="0em"
                  >
                    <tspan x={849.432} y={888.129}>
                      TG
                    </tspan>
                  </text>
                </g>
              </g>
              <text
                id="Title_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={811.172} y={942.448}>
                  Thyroglobulin
                </tspan>
              </text>
            </g>
          </g>
          <text
            id="Iodide uptake from blood into thyroid cells"
            fill="black"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
            fontFamily="Gilroy W05 Medium"
            fontSize={16}
            letterSpacing="0em"
          >
            <tspan x={476} y={457.448}>
              Iodide uptake from blood into thyroid cells
            </tspan>
          </text>
          <text
            id="Inactive"
            fill="black"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
            fontFamily="Gilroy W05 Medium"
            fontSize={16}
            letterSpacing="0em"
          >
            <tspan x={547} y={1142.45}>
              Inactive
            </tspan>
          </text>
          <text
            id="Inactivation of hydrogen peroxide by GPX1"
            fill="black"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
            fontFamily="Gilroy W05 Medium"
            fontSize={16}
            letterSpacing="0em"
          >
            <tspan x={315} y={1202.45}>
              Inactivation of{" "}
            </tspan>
            <tspan x={315} y={1230.45}>
              hydrogen peroxide{" "}
            </tspan>
            <tspan x={315} y={1258.45}>
              by GPX1
            </tspan>
          </text>
          <path
            id="Vector 290"
            d="M508 1009L500.98 1004.99L501.02 1013.08L508 1009ZM380 1174L380.7 1174C380.697 1173.55 380.696 1173.1 380.697 1172.64L379.997 1172.64L379.297 1172.64C379.296 1173.1 379.297 1173.55 379.3 1174L380 1174ZM380.022 1169.85L380.722 1169.86C380.737 1168.95 380.759 1168.03 380.787 1167.1L380.088 1167.08L379.388 1167.05C379.359 1168 379.337 1168.92 379.322 1169.84L380.022 1169.85ZM380.192 1164.29L380.891 1164.32C380.932 1163.41 380.978 1162.49 381.032 1161.55L380.333 1161.51L379.634 1161.47C379.58 1162.41 379.533 1163.34 379.493 1164.26L380.192 1164.29ZM380.51 1158.74L381.208 1158.78C381.272 1157.87 381.342 1156.95 381.419 1156.01L380.721 1155.96L380.024 1155.9C379.946 1156.84 379.876 1157.77 379.811 1158.69L380.51 1158.74ZM380.966 1153.19L381.663 1153.26C381.75 1152.34 381.843 1151.42 381.942 1150.48L381.246 1150.41L380.55 1150.34C380.45 1151.27 380.356 1152.2 380.269 1153.13L380.966 1153.19ZM381.556 1147.66L382.251 1147.74C382.36 1146.82 382.475 1145.9 382.597 1144.97L381.902 1144.87L381.208 1144.78C381.086 1145.72 380.97 1146.65 380.861 1147.58L381.556 1147.66ZM382.275 1142.14L382.968 1142.24C383.098 1141.32 383.234 1140.41 383.376 1139.48L382.685 1139.38L381.993 1139.27C381.85 1140.2 381.713 1141.12 381.582 1142.04L382.275 1142.14ZM383.123 1136.63L383.814 1136.75C383.964 1135.84 384.121 1134.93 384.283 1134.02L383.594 1133.89L382.905 1133.77C382.741 1134.69 382.584 1135.61 382.433 1136.52L383.123 1136.63ZM384.099 1131.15L384.787 1131.28C384.958 1130.38 385.135 1129.47 385.318 1128.57L384.632 1128.43L383.946 1128.29C383.762 1129.2 383.584 1130.11 383.412 1131.02L384.099 1131.15ZM385.201 1125.69L385.885 1125.84C386.078 1124.94 386.276 1124.04 386.481 1123.14L385.798 1122.98L385.115 1122.83C384.91 1123.74 384.71 1124.64 384.516 1125.55L385.201 1125.69ZM386.429 1120.27L387.11 1120.44C387.325 1119.54 387.546 1118.64 387.774 1117.73L387.095 1117.56L386.416 1117.39C386.187 1118.3 385.965 1119.21 385.749 1120.11L386.429 1120.27ZM387.79 1114.88L388.466 1115.06C388.703 1114.16 388.946 1113.27 389.196 1112.37L388.522 1112.19L387.847 1112C387.596 1112.9 387.352 1113.8 387.113 1114.7L387.79 1114.88ZM389.284 1109.51L389.956 1109.71C390.215 1108.83 390.48 1107.94 390.751 1107.05L390.082 1106.85L389.412 1106.64C389.139 1107.54 388.873 1108.43 388.612 1109.32L389.284 1109.51ZM390.916 1104.19L391.582 1104.4C391.864 1103.53 392.151 1102.65 392.445 1101.77L391.781 1101.55L391.117 1101.33C390.822 1102.21 390.532 1103.09 390.249 1103.97L390.916 1104.19ZM392.684 1098.92L393.345 1099.15C393.65 1098.28 393.962 1097.41 394.28 1096.54L393.623 1096.3L392.966 1096.06C392.645 1096.93 392.331 1097.81 392.024 1098.68L392.684 1098.92ZM394.597 1093.69L395.251 1093.94C395.581 1093.08 395.918 1092.22 396.261 1091.36L395.611 1091.1L394.961 1090.84C394.615 1091.7 394.276 1092.57 393.943 1093.44L394.597 1093.69ZM396.659 1088.52L397.306 1088.79C397.66 1087.94 398.022 1087.09 398.389 1086.24L397.747 1085.96L397.105 1085.68C396.734 1086.54 396.37 1087.39 396.013 1088.25L396.659 1088.52ZM398.875 1083.42L399.513 1083.7C399.893 1082.86 400.28 1082.03 400.673 1081.19L400.04 1080.89L399.407 1080.59C399.01 1081.44 398.62 1082.28 398.237 1083.13L398.875 1083.42ZM401.247 1078.38L401.875 1078.69C402.282 1077.86 402.696 1077.04 403.117 1076.22L402.494 1075.9L401.871 1075.58C401.446 1076.41 401.029 1077.24 400.619 1078.07L401.247 1078.38ZM403.782 1073.43L404.4 1073.76C404.834 1072.95 405.276 1072.13 405.725 1071.33L405.113 1070.99L404.501 1070.65C404.048 1071.46 403.603 1072.28 403.164 1073.1L403.782 1073.43ZM406.486 1068.57L407.091 1068.92C407.554 1068.12 408.024 1067.32 408.501 1066.53L407.902 1066.17L407.303 1065.81C406.821 1066.61 406.347 1067.41 405.88 1068.22L406.486 1068.57ZM409.362 1063.8L409.955 1064.18C410.446 1063.4 410.945 1062.62 411.452 1061.85L410.867 1061.46L410.282 1061.08C409.77 1061.86 409.266 1062.64 408.77 1063.43L409.362 1063.8ZM412.416 1059.15L412.994 1059.55C413.515 1058.79 414.044 1058.03 414.581 1057.28L414.011 1056.87L413.442 1056.47C412.9 1057.22 412.365 1057.99 411.839 1058.76L412.416 1059.15ZM415.652 1054.63L416.213 1055.05C416.765 1054.31 417.324 1053.57 417.891 1052.84L417.339 1052.41L416.787 1051.98C416.214 1052.72 415.648 1053.46 415.091 1054.21L415.652 1054.63ZM419.072 1050.24L419.615 1050.68C420.198 1049.97 420.788 1049.26 421.386 1048.56L420.853 1048.1L420.32 1047.65C419.715 1048.36 419.118 1049.07 418.53 1049.8L419.072 1050.24ZM422.681 1046L423.203 1046.47C423.816 1045.78 424.437 1045.1 425.066 1044.43L424.555 1043.95L424.043 1043.47C423.406 1044.15 422.778 1044.84 422.158 1045.54L422.681 1046ZM426.477 1041.94L426.978 1042.43C427.621 1041.77 428.273 1041.12 428.933 1040.47L428.445 1039.97L427.956 1039.47C427.288 1040.12 426.628 1040.78 425.977 1041.45L426.477 1041.94ZM430.459 1038.05L430.936 1038.57C431.612 1037.94 432.296 1037.32 432.988 1036.71L432.524 1036.18L432.061 1035.66C431.36 1036.28 430.667 1036.91 429.983 1037.54L430.459 1038.05ZM434.627 1034.37L435.077 1034.91C435.782 1034.31 436.495 1033.73 437.217 1033.16L436.781 1032.61L436.344 1032.06C435.613 1032.64 434.891 1033.24 434.177 1033.84L434.627 1034.37ZM438.979 1030.9L439.401 1031.46C440.133 1030.9 440.873 1030.36 441.622 1029.82L441.214 1029.25L440.806 1028.68C440.048 1029.23 439.298 1029.78 438.556 1030.34L438.979 1030.9ZM443.501 1027.66L443.893 1028.24C444.653 1027.72 445.422 1027.22 446.198 1026.72L445.821 1026.13L445.444 1025.54C444.657 1026.05 443.878 1026.56 443.108 1027.08L443.501 1027.66ZM448.181 1024.67L448.542 1025.27C449.332 1024.79 450.13 1024.32 450.937 1023.86L450.592 1023.26L450.247 1022.65C449.429 1023.11 448.62 1023.58 447.819 1024.07L448.181 1024.67ZM453.019 1021.92L453.348 1022.54C454.158 1022.11 454.977 1021.69 455.804 1021.27L455.491 1020.65L455.179 1020.02C454.341 1020.44 453.511 1020.87 452.69 1021.3L453.019 1021.92ZM458.011 1019.43L458.306 1020.07C459.132 1019.68 459.967 1019.31 460.809 1018.94L460.531 1018.3L460.252 1017.66C459.398 1018.03 458.553 1018.41 457.715 1018.8L458.011 1019.43ZM463.1 1017.23L463.362 1017.87C464.216 1017.53 465.079 1017.2 465.949 1016.87L465.705 1016.22L465.461 1015.56C464.578 1015.89 463.704 1016.23 462.839 1016.58L463.1 1017.23ZM468.306 1015.29L468.533 1015.95C469.403 1015.65 470.28 1015.36 471.165 1015.08L470.955 1014.41L470.745 1013.75C469.848 1014.03 468.959 1014.32 468.079 1014.62L468.306 1015.29ZM473.629 1013.61L473.822 1014.28C474.696 1014.03 475.578 1013.79 476.468 1013.56L476.291 1012.88L476.115 1012.2C475.214 1012.44 474.321 1012.68 473.436 1012.94L473.629 1013.61ZM479.001 1012.21L479.16 1012.89C480.057 1012.68 480.961 1012.48 481.873 1012.29L481.73 1011.61L481.587 1010.92C480.664 1011.11 479.749 1011.32 478.841 1011.53L479.001 1012.21ZM484.434 1011.08L484.561 1011.77C485.464 1011.6 486.375 1011.44 487.293 1011.3L487.183 1010.6L487.072 1009.91C486.143 1010.06 485.222 1010.22 484.307 1010.39L484.434 1011.08ZM489.959 1010.19L490.054 1010.89C490.951 1010.76 491.854 1010.65 492.765 1010.55L492.686 1009.85L492.606 1009.16C491.685 1009.26 490.772 1009.38 489.865 1009.5L489.959 1010.19ZM495.454 1009.57L495.518 1010.26C496.442 1010.18 497.374 1010.1 498.313 1010.04L498.264 1009.34L498.214 1008.64C497.266 1008.71 496.324 1008.78 495.389 1008.87L495.454 1009.57ZM501.005 1009.17L501.04 1009.87C501.952 1009.83 502.87 1009.79 503.795 1009.76L503.774 1009.06L503.753 1008.36C502.819 1008.39 501.892 1008.43 500.971 1008.47L501.005 1009.17Z"
            fill="black"
          />
          <text
            id="+_2"
            fill="black"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
            fontFamily="Gilroy W05 Medium"
            fontSize={28}
            letterSpacing="0em"
          >
            <tspan x={521.871} y={985.534}>
              +
            </tspan>
          </text>
          <g id="H202">
            <text
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={515.856} y={1013.45}>
                H
              </tspan>
              <tspan x={532.003} y={1013.45}>
                0
              </tspan>
            </text>
            <text
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={526.653} y={1013.45}>
                &#x2082;
              </tspan>
              <tspan x={542.082} y={1013.45}>
                &#x2082;
              </tspan>
            </text>
          </g>
          <text
            id="Active"
            fill="black"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
            fontFamily="Gilroy W05 Medium"
            fontSize={16}
            letterSpacing="0em"
          >
            <tspan x={929} y={1142.45}>
              Active
            </tspan>
          </text>
          <g id="lines_12">
            <mask id="path-61-inside-1_18284_196592" fill="white">
              <path d="M679 969H859V985H679V969Z" />
            </mask>
            <path
              d="M859 985V986.4H860.4V985H859ZM679 985H677.6V986.4H679V985ZM859 969H857.6V985H859H860.4V969H859ZM859 985V983.6H679V985V986.4H859V985ZM679 985H680.4V969H679H677.6V985H679Z"
              fill="#1A1A1A"
              mask="url(#path-61-inside-1_18284_196592)"
            />
          </g>
          <g id="gene-SLC26A4" {...geneGroupProps("SLC26A4", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M517 582C517 579.791 518.791 578 521 578H613C615.209 578 617 579.791 617 582V610C617 612.209 615.209 614 613 614H521C518.791 614 517 612.209 517 610V582Z"
                fill={slc26a4.lozengeFill}
              />
              <text
                id="gene-lozenge-label"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={534.891} y={601.448}>
                  SLC26A4
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="slc26a4"
              groupId="gene-snps"
              genePalette={slc26a4}
              startX={525}
              startY={616}
              snpCount={getGeneSnpCount("SLC26A4", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-TPO" {...geneGroupProps("TPO", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M483 904C483 901.791 484.791 900 487 900H579C581.209 900 583 901.791 583 904V932C583 934.209 581.209 936 579 936H487C484.791 936 483 934.209 483 932V904Z"
                fill={tpo.lozengeFill}
              />
              <text
                id="gene-lozenge-label_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={517.602} y={923.448}>
                  TPO
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="tpo"
              groupId="gene-snps_2"
              genePalette={tpo}
              startX={491}
              startY={938}
              snpCount={getGeneSnpCount("TPO", expectedSnps, geneColors)}
            />
          </g>
        </g>
      </g>
    </>
  );
};

const SvgNutritionIodineDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={1344}
    viewBox="0 176 1024 1344"
    fill="none"
    {...props}
  >
    <NutritionIodineDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18284_196592">
        <rect width={1024} height={1520} fill="white" />
      </clipPath>
      <clipPath id="clip1_18284_196592">
        <rect width={1024} height={1344} fill="white" transform="translate(0 176)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgNutritionIodineDiagram;
